// 综合

import server from '../server'

const localStorage = window.localStorage
const access_token = localStorage.getItem('access_token') || 'YWRtaW46YWRtaW5fc2VjcmV0'
const token_type = localStorage.getItem('token_type') || 'Basic'

// 根据value值查询码表值（李开明）
const getSysDictValue = function(query) {
    return server({
        method: 'post',
        data: query,
        url: 'sysDict/getSysDictValue',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 获取城市列表的接口（王开国）
const getCitys = function(query) {
    return server({
        method: 'post',
        data: query,
        url: 'sysDict/getCitys',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 根据用户ID 查询 权限信息
const getMenusByUserId = function(query) {
    return server({
        method: 'post',
        data: query,
        url: 'sysUserRole/getMenusByUserId',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 根据地区编码 查询 当前地区级别
const getDictByValue = function(query) {
    return server({
        method: 'post',
        data: query,
        url: 'sysDict/getDictByValue',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 修改密码（李开明）
const changePassword = function(query) {
    return server({
        method: 'post',
        data: query,
        url: 'sysUser/changePassword',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 退出登录
const logout = function(query) {
    return server({
        method: 'post',
        data: query,
        url: 'api/logout',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 退出登录
const checkIndexPwd = function(query) {
    return server({
        method: 'post',
        data: query,
        url: 'sysUser/checkIndexPwd',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 首页和分析模块-查询材料分类以及组合类型
const getMaterialAndComposeType = function(query) {
    return server({
        method: 'post',
        data: query,
        url: 'sysDict/getMaterialAndComposeType',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 首页和分析模块-添加主材-查询组合材料的分页
const selectCombinationsPage = function(query) {
    return server({
        method: 'post',
        data: query,
        url: 'resourceCombination/selectCombinationsPage',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

// 重置密码
const resetPassword = function(query) {
    return server({
        method: 'post',
        data: query,
        url: 'sysUser/resetPassword',
        headers: { 'Authorization': localStorage.getItem('token_type') + ' ' + localStorage.getItem('access_token') },
    })
}

export { getSysDictValue, getCitys, getMenusByUserId, getDictByValue, changePassword, logout, 
    checkIndexPwd, getMaterialAndComposeType, selectCombinationsPage, resetPassword }


// WEBPACK FOOTER //
// ./src/api/module/common.js